import { useEffect, useRef, useState } from 'react';
import { useMemoizedFn, useUnmount } from 'ahooks';
import { TMetricGameData } from '@intelligence/pages/Compare/PcConsoleGamesBeta/components/VisualList/hooks/useMetricGameData';

const pageSize = 10;

// 监听底部元素距离加载数据
function useLazyLoadVisualCardList(metricDataList: TMetricGameData): TMetricGameData {
  const target = document.querySelector('.dbi-body .tea-layout__content');

  const observerRef = useRef<IntersectionObserver>();

  // 显示到的数据索引，即当前显示的数据量
  const latestIndexRef = useRef<number>(pageSize);
  // 最终展示数据
  const [lazyLoadDataList, setLazyLoadDataList] = useState<TMetricGameData>([]);

  const allDataLength = metricDataList?.length;

  const loadMoreData = useMemoizedFn((isReload?: boolean) => {
    // 当前显示数量超出总数，直接使用当前值或默认值
    if (latestIndexRef.current >= allDataLength || !allDataLength) {
      latestIndexRef.current = latestIndexRef.current;
    } else {
      // 触发重载时不需要更改当前显示数量
      latestIndexRef.current = isReload
        ? latestIndexRef.current
        : latestIndexRef.current + pageSize;
    }

    const renderDataList = metricDataList.slice(0, latestIndexRef.current);

    setLazyLoadDataList(renderDataList);

    lazyLoadObserver();
  });

  const lazyLoadObserver = () => {
    setTimeout(() => {
      const sentinel = document.querySelector('#dbi_compare_visual_card_sentinel');

      observerRef.current?.disconnect();
      observerRef.current = new IntersectionObserver(
        (entries) => {
          // 当“哨兵”元素进入可视区域时触发加载
          if (entries[0].isIntersecting) {
            observerRef.current?.disconnect();
            loadMoreData();
          }
        },
        // rootMargin 用于提前加载
        { root: target, rootMargin: '100px' },
      );

      sentinel && observerRef.current.observe(sentinel);
    });
  };

  useEffect(() => {
    loadMoreData(true);
  }, [metricDataList, allDataLength]);

  useUnmount(() => {
    observerRef.current?.disconnect();
  });

  return lazyLoadDataList;
}

export default useLazyLoadVisualCardList;
